<button type="button" class="{{buttonType}}" style="border-color: #ccc;" (click)="open()">
    <fa-icon *ngIf="icon" [icon]="icon"></fa-icon>
    {{name}}
</button>